import 'amfe-flexible';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import Vant from 'vant';
Vue.use(Vant);
import 'vant/lib/index.css';

import { vueBaberrage } from "vue-baberrage";
Vue.use(vueBaberrage);

import vueEsign from 'vue-esign'
Vue.use(vueEsign)

import vueSlotMachine from 'vue-slot-machine'
Vue.use(vueSlotMachine);
// import VueCanvasPoster from 'vue-canvas-poster'
// Vue.use(VueCanvasPoster)

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']

// import { imgsPreloader } from './util/imgPreloader.js';
// import imgPreloaderList from './util/imgPreloaderList.js';
// (async () => {
//   await imgsPreloader(imgPreloaderList);
//   // 关闭加载弹框
//   document.querySelector('.loading').style.display = 'none';
//   new Vue({
//     router,
//     store,
//     render: h => h(App)
//   }).$mount('#app');
// })();

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
